import type { OptionDB } from "@project/emerge";
import type { FlightCaseSettings } from "../../interfaces/FlightCaseSettings";
import { CaseCornerDragHandler } from "./CaseCornerDragHandler";
import { Rack19CornerDragHandler } from "./Rack19CornerDragHandler";
import { RackCornerDragHandler } from "./RackCornerDragHandler";
import type { CornerDragHandler } from "./types";

export * from "./types";
export { CaseCornerDragHandler } from "./CaseCornerDragHandler";
export { RackCornerDragHandler } from "./RackCornerDragHandler";
export { Rack19CornerDragHandler } from "./Rack19CornerDragHandler";

/**
 * All corner drag handlers in priority order.
 */
const handlers: CornerDragHandler[] = [
  Rack19CornerDragHandler,
  RackCornerDragHandler,
  CaseCornerDragHandler,
];

/**
 * Get the appropriate drag handler for the current settings.
 * Returns null if no handler is applicable.
 */
export function getCornerDragHandler(
  optionDb: OptionDB,
  settings: FlightCaseSettings,
  buildstepName: string,
): CornerDragHandler | null {
  for (const handler of handlers) {
    if (handler.shouldEnable(settings, buildstepName, optionDb)) {
      return handler;
    }
  }
  return null;
}

